import { get } from "@insite/client-framework/Services/ApiService";
import { AuthenticationResponseModel } from "@rightstore/Model/AuthenticationResponse.model";

export async function ValidatAndAutoLogin(env?:string) {    
    const authenticatorValidateAndAutoLoginResponse = await get<AuthenticationResponseModel>(`/api/v1/authenticator/ValidateAndAutoLogin`, undefined , env ? {'env': env} : undefined );    
    if (authenticatorValidateAndAutoLoginResponse && authenticatorValidateAndAutoLoginResponse.LoginSuccess) {
        return { loggedIn: true, shouldReload: true }
    }
    return { loggedIn: false };
}

export async function LogOutFromPortal(){
    const authenticatorValidateAndAutoLoginResponse = await get<string>(`/api/v1/authenticator/SignOut`, undefined , undefined );
    if (authenticatorValidateAndAutoLoginResponse) {
        return true;
    }
    return false;
}